import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  value: '+560',
  label: 'Páginas'
}, {
  value: '+80',
  label: 'Protocolos'
}, {
  value: '6',
  label: 'Tomos'
}, {
  value: '6',
  label: 'Bonos'
}];
const tags = ['Triage Pediátrico', 'Triángulo de Evaluación (TEP)', 'Bronquiolitis', 'Crisis Asmática', 'Lactante Febril', 'Sepsis Pediátrica', 'Convulsión Febril', 'Estado Epiléptico', 'Deshidratación', 'Gastroenteritis', 'Dolor Abdominal Agudo', 'Documentación en Guardia', 'Alta Voluntaria', 'Comunicación bajo presión', 'Responsabilidad Médica'];
export function Stats() {
  return <section className="bg-blue-900 py-8 sm:py-28 text-white relative overflow-hidden" data-id="element-332">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-333"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-teal-500 rounded-full blur-[100px] opacity-20" data-id="element-334"></div>

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-335">
        <div className="text-center max-w-3xl mx-auto mb-6 sm:mb-16" data-id="element-336">
          <h2 className="text-xl font-bold tracking-tight sm:text-4xl mb-2 sm:mb-4" data-id="element-337">
            El sistema más completo de guardia pediátrica para el médico
            argentino
          </h2>
          <p className="text-xs sm:text-xl text-blue-200 font-medium" data-id="element-338">
            Funciona desde tu próxima guardia
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-8 mb-8 sm:mb-20 max-w-4xl mx-auto" data-id="element-339">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} whileHover={{
          scale: 1.1
        }} className="text-center cursor-pointer" data-id="element-340">
              <div className="text-2xl sm:text-5xl font-bold text-white mb-1 sm:mb-2 tracking-tight drop-shadow-lg" data-id="element-341">
                {stat.value}
              </div>
              <div className="text-blue-200 font-medium uppercase tracking-wider text-[10px] sm:text-sm" data-id="element-342">
                {stat.label}
              </div>
            </motion.div>)}
        </div>

        <div className="max-w-5xl mx-auto" data-id="element-343">
          <p className="text-center text-[10px] sm:text-sm font-semibold tracking-wide text-teal-300 uppercase mb-3 sm:mb-6" data-id="element-344">
            Situaciones cubiertas:
          </p>
          <div className="flex flex-wrap justify-center gap-1.5 sm:gap-3" data-id="element-345">
            {tags.map((tag, index) => <motion.span key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.02
          }} whileHover={{
            scale: 1.05,
            backgroundColor: 'rgba(255,255,255,0.2)'
          }} className="inline-flex items-center px-2.5 py-1 sm:px-4 sm:py-2 rounded-full bg-white/10 text-blue-50 text-[9px] sm:text-sm font-medium ring-1 ring-white/20 backdrop-blur-sm cursor-pointer transition-colors" data-id="element-346">
                {tag}
              </motion.span>)}
          </div>
        </div>
      </div>
    </section>;
}